// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"00c97cb7","453":"8769c5a6"}[chunkId] + ".chunk.js";
};